import { render, staticRenderFns } from "./TableReceive.vue?vue&type=template&id=35aee45e"
import script from "./TableReceive.vue?vue&type=script&lang=js"
export * from "./TableReceive.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports